import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { NewPostMutationInput } from '../../../shared/data/inputs/new-post-mutation.input';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as homeAction from '../../state/actions/post.action';

@Component({
  selector: 'anms-post-group',
  templateUrl: './post-group-dialog.component.html',
  styleUrls: ['./post-group-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostGroupDialogComponent implements OnInit {
  constructor(
    private store$: Store<fromHome.State>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  createGroupPost(data: NewPostMutationInput): void {
    let input: NewPostMutationInput = {
      ...data,
      privateResourceID: '5f314a48144dc6a6ff20f492',
      privateResourceName: 'GROUP'
    };

    if (this.data?.type === 'post') {
      input = {
        ...data
      };
    }

    if (this.data?.type === 'group') {
      input = {
        ...data,
        privateResourceID: this.data?.groupId,
        privateResourceName: 'GROUP'
      };
    }

    if (input) {
      this.store$.dispatch(new homeAction.CreateNormalPost(input));
    }
  }
}
